import { FilterViewProps } from "@mb-pro-ui/components/table/filters/base/types";
import { Typography } from "@mui/material";
import { useEffect, useMemo } from "react";
import { useIntl } from "react-intl";
import MultiAutocompleteFilter from "./MultiAutocompleteFilter";
import { Company } from "../../utils/types";
import { useMutation } from "react-query";
import { useServerCommunication } from "../../utils/ServerCommunicaton";
import { useErrorHandler } from "../../hooks/useErrorHandler";

type CompanyWithStringId = Omit<Company, "id"> & {
  id: string;
};

const renderOption = (option: CompanyWithStringId) => (
  <Typography noWrap padding="0 10px" maxWidth="100%">
    {option.name}
  </Typography>
);

const getOptionLabel = (option: CompanyWithStringId) => option.name;
const getFilterValue = (option: CompanyWithStringId) => option.id;

export const CompanyAutocompleteFilter = (props: FilterViewProps) => {
  const { formatMessage } = useIntl();
  const { getCompanies } = useServerCommunication();

  const { errorHandler: onError } = useErrorHandler([]);

  const { mutate: getList, data: companiesData } = useMutation({ mutationFn: getCompanies, onError });
  const companies = useMemo<CompanyWithStringId[] | undefined>(() => companiesData?.map(({ id, ...params }) => ({ id: `${id}`, ...params })), [companiesData]);

  useEffect(() => {
    getList();
  }, [getList]);

  return (
    <MultiAutocompleteFilter
      {...props}
      options={companies ?? []}
      getOptionLabel={getOptionLabel}
      renderOption={renderOption}
      getFilterValue={getFilterValue}
      label={formatMessage({
        defaultMessage: "Company",
      })}
      virtualizedRowHeight={40}
      simple
    />
  );
};
